import React from "react";
import Banner from "../Banner/Banner";
import Projects from "../Projects/Projects";
import TopBanner from "../../Shared/TopBanner/TopBanner";
import Header from "../../Shared/Header/Header";
import Skills from "../Skills/Skills";
import ContactMe from "../ContactMe/ContactMe";
import Education from "../../Education/Education";
import HomeExperience from "../HomeExperience/HomeExperience";

const Home = ({ textEnter, textLeave, setCursorVariant }) => {
  return (
    <div>
      <TopBanner textEnter={textEnter} textLeave={textLeave} />
      <Header textEnter={textEnter} textLeave={textLeave} />
      <Banner
        textEnter={textEnter}
        textLeave={textLeave}
        setCursorVariant={setCursorVariant}
      />
      <Skills textEnter={textEnter} textLeave={textLeave} />
      <Education textEnter={textEnter} textLeave={textLeave} />
      <HomeExperience textEnter={textEnter} textLeave={textLeave} />
      <Projects textEnter={textEnter} textLeave={textLeave} />
      <ContactMe textEnter={textEnter} textLeave={textLeave} />
    </div>
  );
};

export default Home;
